import React from 'react';

export default () => (
    <div className="container">
        <div className="header-bar">
            <h1 className="game-title"> Hash Heroes </h1>
        </div>
        <div style={{marginTop: '40px'}} className="game-info">
            <h2> Under Maintenance </h2>
            <p> Just a moment. We'll get things up and running again soon. </p>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/components/MaintenancePage.js